import { useSite } from "@inrange/building-manager-api-client";
import { Nav } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import SitePerformance from "./SitePerformance";
import SiteReadings from "./readings/SiteReadings";
import SiteNav from "./siteSections/SiteNav";

const SitePerformanceTabs = () => {
  const { siteId, tab } = useParams<{ siteId: string; tab: string }>();
  const { fetchSite } = useSite({ siteId, app: "admin" });
  const siteName = fetchSite.data?.site.name;

  const activeTab = tab === "readings" ? "readings" : "forecast";

  document.title =
    activeTab === "readings"
      ? `Site: ${siteName} - Readings`
      : `Site: ${siteName} - Performance`;

  return (
    <>
      <SiteNav />
      <div style={{ padding: "12px", fontSize: "26px" }}>
        {fetchSite?.data?.site?.name}
      </div>
      <div style={{ padding: "8px 12px 0" }}>
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link
              as={Link}
              to={`/site/${siteId}/perf/forecast`}
              active={activeTab === "forecast"}
              replace
            >
              Forecast vs Actual
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              to={`/site/${siteId}/perf/readings`}
              active={activeTab === "readings"}
              replace
            >
              Readings
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="tab-content">
          {activeTab === "forecast" && <SitePerformance />}
          {activeTab === "readings" && <SiteReadings />}
        </div>
      </div>
    </>
  );
};

export default SitePerformanceTabs;
